import React from "react";

function HistoryTaskComment({ items }) {
    if (items && items.length > 0) {
        return <div className="task-comment">
            {items.map(e => e.comment ? < div className="item" >
                <b>{e.nameUser}</b>
                <p>
                    {e.comment}
                </p>
            </div> : null)}
        </div>
    } else {
        return <div></div>
    }
}

export default HistoryTaskComment;